import httpService, { IResponse } from "services/HttpService";
import modelEnv from "../model.env";

interface ModelAsset {
  id: string;
  originalName: string;
  url: string;
}

class PublicModelAssetService {
  static async getModelAssets(
    modelId: string
  ): Promise<IResponse<ModelAsset[]>> {
    const url = `${modelEnv.apiUrl}/${modelId}/assets`;
    const response = await httpService.get(url);
    return response;
  }
}

export default PublicModelAssetService;
